import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    exploracionNeurologica: [],
  },

  getters: {
    getExploracionNeurologica: (state) => state.exploracionNeurologica,
  },

  mutations: {
    SET_EXPLORACION_NEUROLOGICA(state, exploracionNeurologica) {
      state.exploracionNeurologica = exploracionNeurologica;
    },
  },

  actions: {
    async fetchExploracionNeurologica({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/exploracionNeurologica`)
        .then((response) => {
          commit('SET_EXPLORACION_NEUROLOGICA', response.data.data);
        });
    },

    async saveExploracionNeurologica(_, exploracionNeurologica) {
      await axios
        .post(
          `PoliciaCuadrantes/C3/historiaClinica/${exploracionNeurologica.fk_idHistoriaClinica}/exploracionNeurologica`,
          exploracionNeurologica,
        );
    },

    async updateExploracionNeurologica(_, exploracionNeurologica) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            exploracionNeurologica.fk_idHistoriaClinica
          }/exploracionNeurologica/${
            exploracionNeurologica.id}`,
          exploracionNeurologica,
        );
    },
  },
};
